import { loadPublicLayoutStatus } from './publicLayoutApi'

// Explains a null from publicLayout / publicLayoutUpdate / a false publicLayoutDelete.
// Resolves to 'claimed' only when the backend says the layout moved into a workspace;
// anything else - including any failure of the status call itself (e.g. a backend that
// predates publicLayoutStatus answering HTTP 400) - is 'unavailable', so the planner
// falls back to today's behaviour. Never rejects.
export const resolveMissStatus = async layoutUuid => {
  try {
    const status = await loadPublicLayoutStatus(layoutUuid)
    return status === 'CLAIMED' ? 'claimed' : 'unavailable'
  } catch {
    return 'unavailable'
  }
}
